import { Grid, Card, CardContent, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import DraftsIcon from "@mui/icons-material/Drafts";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  MessageBox,
  DeleteIconMessage,
  MessageSeen,
} from "./MessageCard.style";

export default function MessageCard(props) {
  return (
    <Card onClick={props.click} style={{ width: "100% !important" }}>
      <CardContent>
        <Grid
          container
          spacing={0}
          alignItems="center"
          justifyContent="space-between"
          sx={{ cursor: "pointer", width: "100%" }}
        >
          <MessageBox item xs={9}>
            <Typography>{props.index + 1}</Typography>
            <Typography>{props.item.title}</Typography>
            <Typography>{props.item.user}</Typography>
            <Typography>{props.item.updated_at}</Typography>
            {props.item.status == "open" ? (
              <Typography style={{ display: "flex" }}>
                {props.item.admin_seen === true ? (
                  <span
                    style={{
                      width: "20px",
                      height: "20px",
                      backgroundColor: "green",
                      borderRadius: "100%",
                      display: "inline-block",
                    }}
                  />
                ) : (
                  <MessageSeen />
                )}
              </Typography>
            ) : (
              <Typography>بسته شده</Typography>
            )}
          </MessageBox>
        </Grid>
      </CardContent>
    </Card>
  );
}
